import clsx from "classnames";
import { Carousel, Container } from "react-bootstrap";
import ChevronLeft from "@/assets/ChevronLeft.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import { PromotionalCarouselItem, Title, Description } from "@/ui";

import classes from "./styles.module.scss";

export default function PromotionalCarousel({ sectionId, className, bgColor, title, titleColor, description, items }) {
  return (
    <div id={sectionId} className={clsx(className, bgColor, classes.promotional)}>
      <Container className="mw-xxl">
        <Title className={titleColor} title={title} />
        <Description description={description} />
        <Carousel
          className={clsx(className, classes.promotional__carousel)}
          controls={true}
          prevIcon={<ChevronLeft width="14" height="25" />}
          nextIcon={<ChevronRight width="14" height="25" />}
          indicators={false}
        >
          {items.map(({ title, description, img, video_embed_url, button, reverse }, k) => (
            <Carousel.Item key={k}>
              <PromotionalCarouselItem
                title={title}
                description={description}
                img={img?.url}
                video_embed_url={video_embed_url}
                cta={button}
                reverse={reverse ?? null}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </div>
  );
}
